export default __webpack_public_path__ + "static/media/thinking-face.eda3e8c5.png";